<template>
  <div class="fill-height overflow-auto">
    <template v-if="selected">
      <component
        :is="selected.value"
        :inspection="inspection"
      ></component>
    </template>
    <v-list v-else>
      <template v-for="(list, attr, s_index) in items">
        <v-subheader :key="s_index">{{ attr }}</v-subheader>
        <v-list-item
          v-for="(el, e_index) in list"
          :key="s_index + '-' + e_index"
          @click="handleSelect(el, el.title)"
        >
          <v-list-item-avatar>
            <v-avatar :color="el.iconColor || 'blue'">
              <v-icon dark>{{ el.icon }}</v-icon>
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ el.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import ImageCapture from "./activities/ImageCapture.vue"
import Recording from "@/components/video-meeting/side-bar/activities/Recording.vue"
export default {
  name: "SideBarActivities",
  components: {
    "image-capture": ImageCapture,
    recording: Recording
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    inspection: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: null,
      items: {
        Inspection: [
          {
            icon: "mdi-clipboard-text",
            iconColor: "blue",
            title: this.$t("categories.inspection.form"),
            value: "inspection-form"
          },
          {
            icon: "mdi-alert",
            iconColor: "error",
            title: this.$tc("categories.nonconformity.name", 1),
            value: "non-conformities"
          }
        ],
        "Tools and settings": [
          {
            icon: "mdi-video-outline",
            iconColor: "error",
            title: this.$t("commons.record"),
            value: "recording"
          },
          {
            icon: "mdi-image-multiple-outline",
            iconColor: "success",
            title: this.$t("commons.capture"),
            value: "image-capture"
          }
        ]
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue === null) this.selected = null
    }
  },
  methods: {
    // Open dialog for Inspection form in meeting
    handleSelect(el) {
      if (el.value == "non-conformities") {
        this.$store.commit("dialog/setRoute", {
          name: "NonConformityCreateUpdate"
        })
      } else if (el.value == "inspection-form") {
        this.$store.commit("dialog/setRoute", {
          name: "InspectionDocumentEditorView",
          params: { inspection: this.inspection }
        })
      } else {
        this.selected = el
        this.$emit("input", this.selected)
      }
    }
  }
}
</script>
